export default "__VITE_ASSET__B6xGzFk8__"